import * as $util from '@/utils/util';

/**
 * 初始化组件，生成key-value返回，并改变配置（增加viewName）
 * @param widgetMenuList 组件菜单
 * @param widgetPackage 组件库
 */
export function registerWidget(widgetMenuList, widgetPackage) {
  let viewAndFormWidgets = {}
  widgetMenuList.forEach(widgetMenu => {

    let widgetName = widgetMenu.widgetName;
    let widgetPack = widgetPackage[widgetMenu.widgetName];

    if (widgetPack) {
      // 获取定义好的组件属性
      widgetMenu.widgetProps = widgetPack.widgetProps;
      // 注册时候时候名称
      // widgetViewName(视图层名称): ViewTitle,
      // widgetFormName(属性的表单名): FormTitle

      // 提取view组件
      widgetMenu.widgetProps.widgetViewName = `${widgetName}View`;
      viewAndFormWidgets[widgetMenu.widgetProps.widgetViewName] = widgetPack.View

      // 提取Form属性组件
      if (widgetPack.Form) {
        widgetMenu.widgetProps.widgetFormName = `${widgetName}Form`;
        viewAndFormWidgets[widgetMenu.widgetProps.widgetFormName] = widgetPack.Form
      }
    }
  })
  return viewAndFormWidgets;
}

/**
 * 初始化View组件，用于预览显示
 * @param widgetMenuList 组件菜单
 * @param widgetPackage 组件库
 */
export function registerViewWidget(widgetPackage) {
  let viewWidgets = {}
  let keys = Object.keys(widgetPackage);
  keys.forEach(widgetName => {
    let widgetPack = widgetPackage[widgetName];
    if (widgetPack) {
      let widgetViewName = `${widgetName}View`;
      viewWidgets[widgetViewName] = widgetPack.View
    }
  })
  return viewWidgets;
}

/**
 * 处理 db数据和模板数据，返回merge后新包含数据的模板节点数据
 *
 * @param widgetTemplateMap 组件模板
 * @param apiData db数据
 * @return {Array} 组件库和db数据merge处理的数组
 */
export function api2Vnode(widgetTemplateMap, apiData) {
  let vnodeList = [];
  apiData.forEach(dbData => {
    let widgetConfig = widgetTemplateMap[dbData.widgetName]
    if (widgetConfig) {
      // 组件库和db数据merge处理
      let widgetData = JSON.parse(JSON.stringify(widgetConfig));
      let data = $util.mergeObject(widgetData, dbData);
      vnodeList.push(data);
    }
  })
  return vnodeList;
}

/**
 * 从模板组件库copy指定名称组件
 *
 * @param widgetMenu 组件菜单
 * @return {{}} 复制的组件
 */
export function copyVnodeByName(widgetMenu) {
  return JSON.parse(JSON.stringify(widgetMenu));
}

/**
 * 把第index位置向下移动
 *
 * @param target
 * @param item
 */
export function arrayIsFirst(target, item) {
  return target.indexOf(item) === 0;
}

/**
 * 把第index位置向下移动
 *
 * @param target
 * @param item
 */
export function arrayIsLast(target, item) {
  return target.indexOf(item) === target.length - 1;
}

/**
 * copy一份item
 *
 * @param target
 * @param item
 */
export function arrayCopy(target, item) {
  if (!target || target.length <= 0) return;
  let index = target.indexOf(item);
  let newItem = {...item, id: $util.UUID(), isEdit: false}
  target.splice(index + 1, 0, newItem) // 从当前删除2两，增加两个
}

/**
 * copy一份item
 *
 * @param target
 * @param item
 */
export function arrayRemove(target, item) {
  if (!target || target.length <= 0) return;
  let index = target.indexOf(item);
  target.splice(index, 1)
}

/**
 * 把item位置向下移动
 *
 * @param target
 * @param item
 */
export function arrayMoveUp(target, item) {
  if (!target || target.length <= 0) return;
  let index = target.indexOf(item);
  if (index === 0) return;
  // 交互不会触发arrays数据刷新dom
  // let tmp = target[index -1];
  // target[index - 1] = target[index];
  // target[index] = tmp;
  let newArray = [item, target[index - 1]];
  target.splice(index - 1, 2, ...newArray) // 从上一个删除2两，增加两个
}

/**
 * 把item位置向下移动
 *
 * @param target
 * @param item
 */
export function arrayMoveDown(target, item) {
  if (!target || target.length <= 0) return;
  let index = target.indexOf(item);
  if (index === target.length - 1) return;
  // let tmp = target[index];
  // target[index] = target[index + 1];
  // target[index + 1] = tmp;

  let newArray = [target[index + 1], item];
  target.splice(index, 2, ...newArray) // 从当前删除2两，增加两个
}
